import { render, staticRenderFns } from "./FilterRate.vue?vue&type=template&id=47be54ef&"
import script from "./FilterRate.vue?vue&type=script&lang=js&"
export * from "./FilterRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports